import React, {PureComponent} from "react"

import theme from "@irati/ui/src/global/theme"
import {Text} from "./styled"

interface Props {
  x: number,
  y: number,
  value: string,
  isFocused: boolean
}

class CustomizedLabel extends PureComponent<Props> {
  render() {
    const {x, y, value, isFocused} = this.props
    return <Text x={x} y={y} fill={isFocused ? theme.colors.primary1 : theme.colors.primary2}>{value}</Text>
  }
}

export default CustomizedLabel
